import CourseList from "./ListView";
import withCourses from "../Fetch/withCourses";

export default withCourses(CourseList);
